import React, {useEffect, useState} from "react";
import {Ajax} from "../../Service/ajax";
import TeamNavbar from "./TeamNavBar";
import {hosts} from "../../env/Environment";
import Swal from "sweetalert2";
import {CheckCircle, XCircle} from "lucide-react";
import {isValid} from "date-fns";
import ReactQuill from "react-quill";

export default function EditCompanyForm({title}) {
    const [loading, setLoading] = useState(false);
    const application=JSON.parse(sessionStorage.getItem("application"));
    const {id, description, pageUrl} = application;
    const [changing, setChanging] = useState(false);
    const [changingName, setChangingName] = useState(false);
    const [changingDesc, setChangingDesc] = useState(false);
    const [newPage, setNewPage] = useState('');
    const [newName, setNewName] = useState('');
    const [message, setMessage] = useState('');
    const [type, setType] = useState('success');
    const [isValid, setIsValid] = useState(false);
    const [isValidName, setIsValidName] = useState(false);
    const [newDescription, setNewDescription] = useState('');
    const [realDescription, setRealDescription] = useState("");


    const handlePageChange = async () => {
        setChanging(true);
        let newPageUrl = newPage
            .toLowerCase()
            .replace(/\s+/g, '-');
        try {
            const {data} = await Ajax.putRequest(`/api/v1/sub/application/update/page/${application.id}?newPageUrl=${newPageUrl}`);
            if(!data.error){
                sessionStorage.setItem("application", JSON.stringify(data.object));
                setMessage(data.message);
                setType('success');
            }else{
                setMessage(data.message);
                setType('danger');
            }
        }catch (error){
            setMessage("Une erreur s'est produite, veuillez réessayer.");
            setType('danger');
        }finally {
            setChanging(false);
            setNewPage('');
        }
    }

    const handleChangeNt = (value) => {
        setNewDescription(value);

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = value;
        const plainText = tempDiv.textContent || tempDiv.innerText || "";

        setRealDescription(plainText.trim());
    };

    const handleNameChange = async () => {
        setChangingName(true);
        try {
            const { data } = await Ajax.putRequest(
                `/api/v1/sub/application/update/name/${application.id}?newName=${encodeURIComponent(newName)}`
            );
            if (!data.error) {
                sessionStorage.setItem("application", JSON.stringify(data.object));
                setMessage(data.message);
                setType('success');
            } else {
                setMessage(data.message);
                setType('danger');
            }
        } catch (error) {
            setMessage("Une erreur s'est produite, veuillez réessayer.");
            setType('danger');
        } finally {
            setChangingName(false);
            setNewPage('');
        }
    };

    const handleDescriptionChange = async () => {
        setChangingDesc(true);
        try {
            const { data } = await Ajax.putRequest(
                `/api/v1/sub/application/update/description/${application.id}?newDescription=${encodeURIComponent(newDescription)}`
            );
            if (!data.error) {
                sessionStorage.setItem("application", JSON.stringify(data.object));
                setMessage(data.message);
                setType('success');
            } else {
                setMessage(data.message);
                setType('danger');
            }
        } catch (error) {
            setMessage("Une erreur s'est produite, veuillez réessayer.");
            setType('danger');
        } finally {
            setChangingDesc(false);
            setNewDescription("")
            setRealDescription("");
        }
    };


    function validerTexte(input) {
        const regex = /^[a-z0-9\-_]+$/;
        return regex.test(input);
    }

    function validerName(input) {
        const regex = /^[a-z0-9A-Z\-]+$/;
        return regex.test(input);
    }

    const validateDescription = (description) => {
        const minLength = 10;
        const maxLength = 255;

        if (!description) return false;

        // Convertir HTML en texte brut
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = description;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";

        const cleaned = textContent.trim();

        const length = cleaned.length;

        return length >= minLength && length <= maxLength;
    };


    const isDescriptionValid = validateDescription(newDescription);


    useEffect(() => {
        setTimeout(() => {
            setMessage("");
            setType('success');
        }, 2000);
    },[message])

    return (
        <div className="modal-content">
            <div className="modal-header">
                <TeamNavbar title={title}/>

            </div>
            <div className="modal-body">
                {loading ?
                    <div className="col-md-12 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <i className="bx bx-group mb-3" style={{ fontSize: "3rem", color: "#eccd7e" }}></i>
                            <h2 className="text-center mb-3">
                                Bienvenue dans l'espace de gestion des équipes
                            </h2>
                            <p className="text-center mb-4">
                                Chargement des données, veuillez patienter...
                            </p>
                            <div className="spinner-border spinner-border-lg text-netikash" role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </div>
                        </div>
                    </div>
                    :(
                    <>
                        <div className="col-md-12 d-flex flex-column align-items-center container-xxl" style={{ minHeight: "60vh" }}>
                            {/* En-tête */}
                            <div className="d-flex justify-content-between w-100 mb-1" style={{ height: "30px" }}>
                                <h6>Nom de page</h6>
                            </div>

                            <div className="w-100 border-bottom mb-2 pb-2">
                                {message && (
                                    <div id="alert-container">
                                        <div
                                            className={`alert alert-${type} alert-dismissible fade show`}
                                            role="alert"
                                            style={{ transition: "opacity 0.5s ease" }}
                                        >
                                            {message}
                                        </div>
                                    </div>
                                )
                                }
                                {/* Texte explicatif */}
                                <div className="mb-2">
                                    <small className="text-muted">Personnalisez votre expérience en donnant un nom unique à votre page. Vous pouvez modifier le nom actuel ou en choisir un nouveau qui reflète votre identité ou le but de votre page. Faites de votre page un espace qui vous ressemble !_</small>
                                </div>

                                {/* Champs de formulaire et boutons */}
                                <div className="d-flex" style={{ alignItems: "flex-end", height: "40px" }}>
                                    <div className="form-control d-flex align-items-center form-control-sm me-2" style={{ maxWidth: "600px"}}>
                                        <span className="text-muted" style={{ whiteSpace: "nowrap" }}>
                                            {hosts.api === "https://api.netikash.com" ? "https://subscribe.netikash.com" : "https://devsubscribe.netikash.com"}/
                                        </span>
                                        <input
                                            type="text"
                                            className="border-0 flex-grow-1"
                                            placeholder={application.pageUrl}
                                            onChange={(e) => {
                                                setNewPage(e.target.value);
                                                setIsValid(validerTexte(e.target.value));
                                            }}
                                            style={{ outline: "none" }}
                                            maxLength={20}
                                        />

                                        {isValid === true && (
                                            <CheckCircle color="green" size={20} className="ms-2" />
                                        )}
                                        {isValid === false && (
                                            <XCircle color="red" size={20} className="ms-2" />
                                        )}
                                    </div>


                                    <button className="btn btn-netikash btn-sm me-2" style={{ minWidth: "50px"}} onClick={() => handlePageChange()} disabled={!newPage}>
                                        {changing ? "Changement en cours......" : "Changer le nom de page"}
                                    </button>

                                    <button className="btn btn-outline-netikash btn-sm"
                                            onClick={()=>setNewPage("")}
                                    >
                                        Annuler
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between w-100 mb-1" style={{ height: "30px" }}>
                                <h6>Nom de l'organisation</h6>
                            </div>

                            {/* Liste des rôles avec bordure alignée */}
                            <div className="w-100 border-bottom mb-2 pb-2">
                                <div className="mb-2">
                                    <small className="text-muted">
                                        Modifiez le nom de votre organisation pour qu'il reflète au mieux son identité ou sa mission. Assurez-vous de choisir un nom unique qui représente parfaitement votre entreprise.
                                    </small>
                                </div>

                                <div className="d-flex" style={{ alignItems: "flex-end", height: "40px" }}>
                                    <div className="form-control d-flex align-items-center form-control-sm me-2" style={{ maxWidth: "600px"}}>
                                        <span className="text-muted" style={{ whiteSpace: "nowrap" }}>
                                            Netikash Subscription-
                                        </span>
                                        <input
                                            type="text"
                                            className="border-0 flex-grow-1"
                                            placeholder={application.title}
                                            onChange={(e) => {
                                                setNewName(e.target.value);
                                                setIsValidName(validerName(e.target.value));
                                            }}
                                            style={{ outline: "none" }}
                                            maxLength={20}
                                        />

                                        {isValidName === true && (
                                            <CheckCircle color="green" size={20} className="ms-2" />
                                        )}
                                        {isValidName === false && (
                                            <XCircle color="red" size={20} className="ms-2" />
                                        )}
                                    </div>


                                    <button className="btn btn-netikash btn-sm me-2" style={{ minWidth: "50px"}} onClick={() => handleNameChange()} disabled={!newName}>
                                        {changingName ? "Changement en cours......" : "Changer le nom de l'organisation"}
                                    </button>

                                    <button className="btn btn-outline-netikash btn-sm"
                                            onClick={()=>setNewName("")}
                                    >
                                        Annuler
                                    </button>
                                </div>

                            </div>

                            <div className="d-flex justify-content-between w-100 mb-1" style={{ height: "30px" }}>
                                <h6>Description de l'organisation (Max 255 caractères)</h6>
                            </div>

                            {/* Liste des rôles avec bordure alignée */}
                            <div className="w-100 border-bottom mb-2 pb-2">
                                <div className="mb-2">
                                    <small className="text-muted">
                                        Modifiez la description de votre organisation afin qu'elle reflète fidèlement son activité, ses objectifs et sa mission. Une bonne description aide à mieux communiquer votre identité et valeurs.
                                    </small>
                                </div>

                                <div>
                                    <ReactQuill
                                        theme="snow"
                                        style={{ width: "100%" }}
                                        value={newDescription}
                                        onChange={handleChangeNt}
                                    />
                                    <div className="d-flex align-items-center mt-2">
                                        {isDescriptionValid ? (
                                            <span className="tf-icons bx bx-check-circle text-success" style={{ fontSize: "1.5rem", marginRight: "8px" }}></span>
                                        ) : (
                                            <span className="tf-icons bx bx-x-circle text-danger" style={{ fontSize: "1.5rem", marginRight: "8px" }}></span>
                                        )}
                                        <span>{Math.max(0, 255 - realDescription.length)} caractères restants</span>
                                    </div>

                                    <div className="d-flex" style={{ marginTop: "1rem" }}>
                                        <button
                                            className="btn btn-netikash btn-sm me-2"
                                            style={{ minWidth: "50px" }}
                                            onClick={() => handleDescriptionChange()}
                                            disabled={!isDescriptionValid}
                                        >
                                            {changingDesc ? "Changement en cours......" : "Changer la description de l'organisation"}
                                        </button>

                                        <button className="btn btn-outline-netikash btn-sm"
                                        onClick={()=>setNewDescription("")}>
                                            Annuler
                                        </button>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </>
                )}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-outline-netikash" data-bs-dismiss="modal" onClick={()=>console.log("close")}>
                    Fermer
                </button>
            </div>
        </div>
    );
}